import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const GTKMErrorModal = () => {
  return /*#__PURE__*/_jsx(View, {
    as: "div",
    marginBlockEnd: "25",
    marginBlockStart: "1400",
    marginInline: "auto",
    maxInlineSize: "600px",
    children: /*#__PURE__*/_jsx(Alert, {
      titleText: I18n.text('views.INDUSTRY.breezeFailedErrorModal.title'),
      type: "warning",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `views.INDUSTRY.breezeFailedErrorModal.text`
      })
    })
  });
};
export default GTKMErrorModal;